/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { LogoMultiCardFragment } from "@cosmos/hygraph-schema";

import { css, cx } from "@panda/css";
import { Flex } from "@panda/jsx";
import { SystemStyleObject } from "@panda/types";

import { LogoCard } from "./LogoCard.molecule";
import { ColorToken } from "@panda/tokens";

const Layout_2cards: SystemStyleObject = {
	flexDir: "row",
	smDown: { flexDir: "column" },

	// Intentionally chooses this approach over making LogoCard accepts
	// a cusomtCss object of type SystemStyleObject because this approach
	// doesn't need extra javascript to decide whether to a min width on the card.
	"& > .logo-card": {
		flexBasis: "0",
		flexGrow: "1",
		base: {
			minW: "340px",
		},
		mdDown: {
			minW: "280px",
		},
		xsDown: {
			w: "full",
			minW: "auto",
		},
	},
};

const Layout_3cards: SystemStyleObject = {
	flexDir: "row",
	mdDown: { flexDir: "column" },
};

export type LogoMultiCardsProps = {
	cards: LogoMultiCardFragment[];
	descriptionColor?: ColorToken;
};

export function LogoMultiCards({ cards, descriptionColor }: LogoMultiCardsProps): React.JSX.Element {
	return (
		<Flex
			gap="eds.dimension.16"
			className={cx("logo-multi-cards", css(cards.length === 2 ? Layout_2cards : Layout_3cards))}
		>
			{cards.map((card, i) => (
				<LogoCard key={`logo-card-${i}`} {...card} descriptionColor={descriptionColor} />
			))}
		</Flex>
	);
}
